import { validatePasswordStrength } from 'anchor-password-policy';
const MINIMUM_LENGTH = 10;
export function validatePassword(password, userInputs, isStrongPolicyEnabled) {
    if (!isStrongPolicyEnabled) {
        return password.length >= MINIMUM_LENGTH || 'Password must be at least 10 characters';
    }
    return validatePasswordStrength(password, userInputs) || 'Password is not strong enough';
}
